'use client';

import {
  useEffect
} from 'react';

import
  Link
from 'next/link';

import {
  BRAND_GRADIENT,
  BRAND_GRADIENT_DARK_GLASS,
  PRIMARY_BUTTON_CLASSES
} from '@repo/brand';

export default function MarketingError({
  error,
  reset
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {

  useEffect(() => {

    console.error('[Marketing error]', error);
  }, [ error ]);

  return (
    <section className="min-h-[70vh] flex items-center justify-center px-6 sm:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <h1
          className="text-[100px] sm:text-[140px] font-bold leading-none select-none"
          style={{
            background: BRAND_GRADIENT,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}
        >
          500
        </h1>

        <h2 className="text-2xl sm:text-3xl font-light text-[#111111] dark:text-white mt-4 mb-4">
          Something went wrong
        </h2>

        <p className="text-base text-gray-500 dark:text-gray-400 mb-10 max-w-md mx-auto leading-relaxed">
          An unexpected error occurred. You can try again or head back home.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            type="button"
            onClick={reset}
            className={`inline-flex items-center gap-2 px-7 py-3.5 ${ PRIMARY_BUTTON_CLASSES } ${ BRAND_GRADIENT_DARK_GLASS }`}
            style={{
              background: BRAND_GRADIENT
            }}
          >
            Try again
          </button>

          <Link
            href="/"
            className="inline-flex items-center gap-3 text-sm font-semibold px-7 py-3.5 rounded-full border-2 transition-all duration-200 text-[#111111] dark:text-white hover:text-white"
            style={{
              borderColor: 'rgba(1,158,250,0.6)'
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = BRAND_GRADIENT)}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
          >
            Back to home
          </Link>
        </div>
      </div>
    </section>
  );
}
